module.exports = __webpack_public_path__ + "img/support.4bfea944.png";